import PropTypes from 'prop-types';
import { TFormLabel } from './form_label';

const TFormOptions = PropTypes.arrayOf(TFormLabel);

export { TFormOptions };
